import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Integrations => ');

// ################################################################################################################
// SETUP/TEARDOWN
// ################################################################################################################

const bootstrap = createAction('bootstrap experience integrations', (containerRef, classRef, scope) => ({
  containerRef,
  classRef,
  scope,
}));
const bootstrapSuccess = createAction(
  'successfully bootstraped experience integrations',
  (containerRef, classRef, scope) => ({
    containerRef,
    classRef,
    scope,
  })
);
const bootstrapFailure = createApiFailureAction('failed to bootstrap experience integrations');

const reset = createAction('reset integrations app');

// ################################################################################################################
// UI
// ################################################################################################################

const openIntegrationPicker = createAction('open integration template picker');
const closeIntegrationPicker = createAction('close integration template picker');

const editIntegration = createAction('start integration edit', (integrationId) => ({ integrationId }));
const editIntegrationSuccess = createAction('start integration edit success', (integration, context) => ({
  integration,
  context,
}));
const editIntegrationFailure = createApiFailureAction('start integration edit failure');

const cancelIntegrationEdit = createAction('cancel editing integration');

const updateField = createAction('update field', (fieldId, value) => ({ fieldId, value }));

const saveIntegration = createAction('save integration');
const saveWizardIntegration = createAction('save wizard integration');
const saveIntegrationSuccess = createAction('save integration success');
const saveIntegrationFailure = createAction('save integration failure');

const saveAndActivateIntegration = createAction('save and activate integration ');
const saveAndActivateIntegrationSuccess = createAction('save and activate integration success');
const saveAndActivateIntegrationFailure = createAction('save and activate integration failure');

const processIntegration = createAction('determine a way, the integration will be added', (integrationTemplateId) => ({
  integrationTemplateId,
}));
const addIntegration = createAction('add integration', (template) => ({ template }));
const addWizardIntegration = createAction('add integration', (templateId) => ({ templateId }));
const addIntegrationSuccess = createAction('add integration success');
const addIntegrationFailure = createAction('add integration failure'); // Not an API action so not using createApiFailureAction

const deleteInstance = createAction('delete integration');
const showDeleteModal = createAction('show delete modal', (instanceId, isCredentials) => ({
  instanceId,
  isCredentials,
}));
const hideDeleteModal = createAction('hide delete modal');

const hideUpdateCredentialsModal = createAction('hide update credentials modal');
const showUpdateCredentialsModal = createAction('show update credentials modal');

const disableIntegration = createAction('disable integration');
const showDisableModal = createAction('show disable modal', (integrationId) => ({ integrationId }));
const hideDisableModal = createAction('close disable modal');

const showDebugModal = createAction('show integration debug list modal', (integration) => ({ integration }));
const closeDebugModal = createAction('hide integration debug list modal');
const setActiveDebugSidebarItem = createAction('set active debug sidebar item', (activeItem) => ({ activeItem }));
const fetchDebugData = createAction('fetch debug/error log list', ({ offset }) => ({ offset }));
const fetchDebugDataSuccess = createAction('fetch debug/error log list success', (debugData, count, currentPage) => ({
  debugData,
  count,
  currentPage,
}));
const fetchDebugDataFailure = createApiFailureAction('fetch debug/error log list failure');
const changeDebugFilters = createAction('change debug log filters', (mappings) => ({ mappings }));
const changeDebugDateRangeFilter = createAction('change debug log date range filter', (dateFrom, dateTo) => ({
  dateFrom,
  dateTo,
}));
const toggleDebugDetailsModal = createAction('show/hide integration debug details modal', (isVisible, content) => ({
  isVisible,
  content: content || {},
}));
const resetDebugFilters = createAction('reset debug filters and search');
const clearDebugFilters = createAction('clear debug filters to initial values');

const editIntegrationCredentials = createAction('edit integration credentials', (id) => ({ id }));
const openCredentialsEditionForm = createAction('open credentials edition form', (credentials) => ({
  credentials,
}));
const updateCredentialsField = createAction('update credentials field', (id, value) => ({ id, value }));
const saveIntegrationCredentials = createAction('save integration credentials', (isCreating) => ({ isCreating }));
const toggleIntegrationCredentialsPicker = createAction('toggle integration credentials picker', (isVisible) => ({
  isVisible,
}));
const openCredentialsCreationForm = createAction('open credentials creation form', (typeRef) => ({ typeRef }));
const closeIntegrationCredentialsForm = createAction('close integration credentials edition form');
const toggleDeleteModalMode = createAction('toggle delete modal mode', (isCredentials) => ({ isCredentials }));

const navigate = createAction('navigate to workspace URL path', (path, replace) => ({ path, replace }));

export default {
  bootstrap,
  bootstrapSuccess,
  bootstrapFailure,
  reset,

  disableIntegration,
  showDisableModal,
  hideDisableModal,

  cancelIntegrationEdit,

  editIntegration,
  editIntegrationSuccess,
  editIntegrationFailure,

  updateField,

  saveIntegration,
  saveWizardIntegration,
  saveIntegrationSuccess,
  saveIntegrationFailure,

  saveAndActivateIntegration,
  saveAndActivateIntegrationSuccess,
  saveAndActivateIntegrationFailure,

  addIntegration,
  addWizardIntegration,
  addIntegrationSuccess,
  addIntegrationFailure,

  deleteInstance,
  showDeleteModal,
  hideDeleteModal,
  showUpdateCredentialsModal,
  hideUpdateCredentialsModal,

  processIntegration,
  openIntegrationPicker,
  closeIntegrationPicker,

  showDebugModal,
  closeDebugModal,
  setActiveDebugSidebarItem,
  fetchDebugData,
  fetchDebugDataSuccess,
  fetchDebugDataFailure,
  changeDebugFilters,
  resetDebugFilters,
  clearDebugFilters,
  changeDebugDateRangeFilter,
  toggleDebugDetailsModal,

  editIntegrationCredentials,
  openCredentialsEditionForm,
  updateCredentialsField,
  saveIntegrationCredentials,
  toggleIntegrationCredentialsPicker,
  closeIntegrationCredentialsForm,
  openCredentialsCreationForm,
  toggleDeleteModalMode,

  navigate,
};
